import { useContext, useLayoutEffect, useState } from "react";
import { MenuContext } from "contexts/menu";

import InstanceLabel from "components/Atoms/Datastores/InstanceLabel";
import { useDomains } from "hooks/domains/useDomains";
import { DatabaseOutlined } from "@ant-design/icons";
import { createItem } from "lib/createItem";
import DatastoreIcon from "components/Atoms/Icon/DatastoreIcon";

export default function DomainsMenu() {
  const {
    isDatastoresMenuActive,
    setIsDatastoresMenuActive,
    isDatastoresMenuPinned,
    setIsDatastoresMenuPinned,
  } = useContext(MenuContext);
  const { domainsInfo } = useDomains();
  const onEnter = () =>
    setIsDatastoresMenuActive && setIsDatastoresMenuActive(true);

  const onLeave = () => {
    if (isDatastoresMenuPinned) return;
    setIsDatastoresMenuActive && setIsDatastoresMenuActive(false);
  };
  return (
    <div className="m-auto">
      {domainsInfo &&
        domainsInfo.data &&
        Array.isArray(domainsInfo.data) &&
        domainsInfo.data.map((d) =>
          isDatastoresMenuActive ? (
            <div className="mt-[10px] cursor-pointer" key={d.name}>
              <DatastoreIcon
                type={d.id!}
                width={25}
                height={25}
                className="inline"
              />
              {/* {d.id} */}
              <InstanceLabel
                category={d.config.datastorage as string}
                name={d.id as string}
              />
            </div>
          ) : (
            <div className="flex justify-center mt-[10px]" key={d.name}>
              <DatastoreIcon type={d.id!} width={25} height={25} />
            </div>
          )
        )}
    </div>
  );
}
